import {Component, Input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {MetaData} from '../event-alarms.component';
import {DateTimePipe} from '@brunata-angular/ui';
import {TranslatePipe} from '@brunata-angular/util';
import {MeterEvent} from '../event-alarm.model';

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrl: './events.component.scss',
    standalone: true,
    imports: [TranslatePipe, ReactiveFormsModule, NgbPopover, DateTimePipe],
})
export class EventTableComponent {
    @Input() eventAlarms: MeterEvent[] = [];
    @Input() metaData: MetaData | null = null;
    @Input() header = '';
}
